var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lv-base-column",attrs:{"field":_vm.field}},[_vm._t("default",null,{"row":{},"editRow":{},"col":{},"rowIndex":null,"colIndex":null})],2)}
var staticRenderFns = []

export { render, staticRenderFns }